import { render } from "./MarkComponent.vue?vue&type=template&id=f00351c2&scoped=true"
import script from "./MarkComponent.vue?vue&type=script&lang=js"
export * from "./MarkComponent.vue?vue&type=script&lang=js"

import "./MarkComponent.vue?vue&type=style&index=0&id=f00351c2&scoped=true&lang=css"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00351c2"]])

export default __exports__